import { formatPromoDate, decodeHtmlEntity, formatTime } from './utils.js';

export default function formatDateTimeElement({ startDate, endDate, startTime, endTime }) {
  let dateTime = formatPromoDate(new Date(startDate));

  if (endDate && startDate !== endDate) {
    dateTime = dateTime + ' ' + decodeHtmlEntity('&ndash;') + ' ' + formatPromoDate(new Date(endDate));
  }

  if (startTime || endTime) {
    dateTime = dateTime + ' · ';

    if (startTime && endTime && startTime !== endTime) {
      dateTime = dateTime + ' ' + formatTime(startTime) + decodeHtmlEntity('&nbsp;&ndash;&nbsp;') + formatTime(endTime);
    } else {
      dateTime = dateTime + ' ' + formatTime(startTime) + formatTime(endTime);
    }
  }

  return (
    <p className="label-1">
      {dateTime}
    </p>
  );
}
